import type { ReactNode } from 'react';

export const symbol_bookmark_star: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m480-455 61 37q8 5 16-1t6-16l-16-69 53-46q8-7 5-16t-13-10l-70-6-28-66q-3.87-9-13.94-9-10.06 0-14.06 9l-28 66-70 6q-10 1-13 10t5 16l53 46-16 69q-2 10 6 16t16 1l61-37Zm0 215-196 84q-30 13-57-4.76-27-17.75-27-50.24v-574q0-24 18-42t42-18h440q24 0 42 18t18 42v574q0 32.49-27 50.24Q706-143 676-156l-196-84Zm0-64 220 93v-574H260v574l220-93Zm0-481H260h440-220Z"
		/>
	</svg>
);
